import { InboxStackIcon } from '@heroicons/react/24/outline';
import SaveIcon from '@resources/icons/SaveIcon.svg?react';
import {
  OpenWidgetCommand,
  TeiaViewer,
  TeiaViewerSourceType,
  ToolbarItem,
  useTeiaSource,
  useViewerContext,
  useViewerSelection,
  useWidgetInfo,
} from '@stereograph/teiaviewer';
import { usePluginTranslation } from '@translation';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { TeiaSaveSelectionModal } from './components/TeiaSaveSelectionModal';

export const SaveTeiaObjectsSelection = () => {
  const { t } = usePluginTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const twin = useTeiaSource(TeiaViewerSourceType.Twin);
  const { selection } = useViewerSelection();

  const onClose = () => {
    setIsModalOpen(false);
  };

  const onClick = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <ToolbarItem
        disabled={selection.length === 0 || !twin}
        icon={SaveIcon}
        label={t('toolbar.save.tooltip')}
        onClick={onClick}
        data-dd-action-name="toolbar.save"
      />
      {!!twin && createPortal(
        <TeiaSaveSelectionModal isModalOpen={isModalOpen} onClose={onClose} />,
        document.getElementById('app') as Element,
      )}
    </>
  );
};

export const ShowTeiaSelectionRecordWidget = () => {
  const { t } = usePluginTranslation();
  const { viewer } = useViewerContext<TeiaViewer>();
  const source = useTeiaSource();
  const { isOpened } = useWidgetInfo('TeiaSelectionRecord');

  const onClick = () => {
    const command = new OpenWidgetCommand(viewer, 'TeiaSelectionRecord');
    command.execute();
  };

  const toolbarItemProps = {
    disabled: source === null,
    icon: InboxStackIcon,
    onClick: onClick,
    label: t('toolbar.list_objects.tooltip'),
    active: isOpened,
    dataDdActionName: 'toolbar.list_objects',
  };

  return <ToolbarItem {...toolbarItemProps} />;
};
